import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncActiveLoan = loadable(() => import('./ActiveLoan'), {
  fallback: <Loader />,
});
